import vue from "vue";

export default {
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_COUNTRIES: (state, countries) => {
        state.countries = countries;
    },
    SET_ISSUED_COUNTRIES: (state, issuedCountries) => {
        state.issuedCountries = issuedCountries;
    },
    SET_COUNTRY: (state, country) => {
        state.country = country;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_COUNTRY_TO_EDIT: (state, countryToEdit) => {
        state.countryToEdit = countryToEdit;
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
    SET_IS_ARAB_COUNTRY: (state, isArabCountry) =>{
        state.isArabCountry = isArabCountry;
    },
    SET_CODE: (state, code) => {
        state.code = code;
    },
    SET_DIAL_CODE: (state, code) => {
        state.dialCode = code;
    },
}